import { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import { AppRoutes } from '@/routes';
import { useAuth } from '@/providers';
import { SplashScreen } from '@/components/common/SplashScreen';
import CrocodileGame from '@/components/common/CrocodileGame';
import { useServiceStatusStore } from '@/store/serviceStatusStore';

// Hide the initial HTML splash screen
const hideInitialSplash = () => {
  const splash = document.getElementById('initial-splash');
  if (splash) {
    splash.classList.add('hidden');
    // Remove from DOM after transition
    setTimeout(() => {
      splash.remove();
    }, 300);
  }
};

function App() {
  const { isLoading } = useAuth();
  const isServiceUnavailable = useServiceStatusStore((s) => s.isServiceUnavailable);
  const isOffline = useServiceStatusStore((s) => s.isOffline);
  const setOffline = useServiceStatusStore((s) => s.setOffline);

  useEffect(() => {
    // Hide the initial splash screen once React has mounted
    if (!isLoading) {
      hideInitialSplash();
    }
  }, [isLoading]);

  useEffect(() => {
    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setOffline]);

  const showGame = isServiceUnavailable || isOffline;

  // Show React splash screen while auth is loading
  if (isLoading) {
    return (
      <>
        <CssBaseline />
        <SplashScreen message="Loading..." />
      </>
    );
  }

  return (
    <>
      <CssBaseline />
      <AppRoutes />
      {showGame && <CrocodileGame />}
    </>
  );
}

export default App;
